module.exports = __webpack_public_path__ + "media/assets/faria_products/MB_MAX-a35b4446a97236caaed0111e69dc56afba0502d27d49fc0ae33e789f78d667de.png";